import { get, post, patch, deleteRequest, upload } from "../utils/api";


export const personalShopperItemsListLegacy = (data) => {
  return get(`/personalshopper/items-list?page=1&limit=${data?.sortBy}`);
};

export const threadUser = (data) => {
  return post(`/chat/threads/user`,data);
};

export const threadChat = (data) => {
  const {id}=data;
  return get(`/chat/threads/${id}`);
};


export const personalShopperItemsList = (data) => {
  const statusQuery =
    data?.status && data.status !== "all"
      ? `&status=${encodeURIComponent(data.status)}`
      : "";
  return get(
    `/personal-shopper/items?page=${data?.page || 1}&limit=${data?.limit || data?.sortBy || 10}&search=${encodeURIComponent(data?.search || "")}${statusQuery}`
  );
};

export const personalShopperDropDownList = (data) => {
  return get(`/admin/personal-shopper/list?page=1&limit=${data?.limit}`);
};

function personalShopperItemPath(itemId) {
  const id = itemId == null ? "" : String(itemId).trim();
  if (!id) return null;
  return encodeURIComponent(id);
}

/** PATCH /personal-shopper/items/:itemId — quantity, weight & price */
export const personalShopperProductIntakeUpdate = (data) => {
  const id = data?.id;
  if (!id) return Promise.reject({ data: { message: "Product id is missing" } });
  const body = {};
  if (data.quantity !== undefined) body.quantity = data.quantity;
  if (data.weight !== undefined) body.weight = data.weight;
  if (data.approx_rate !== undefined) body.approx_rate = data.approx_rate;
  return patch(`/personal-shopper/items/${personalShopperItemPath(id)}`, body);
};

/** PATCH /personal-shopper/items/:itemId/change-status */
export const personalShopperProductStatusChange = (data) => {
  const id = data?.id;
  if (!id) return Promise.reject({ data: { message: "Product id is missing" } });
  return patch(`/personal-shopper/items/${personalShopperItemPath(id)}/change-status`, {
    status: data.status,
  });
};

/** PATCH /personal-shopper/items/:itemId/add-note */
export const personalShopperAddNoteToProduct = (id, data) => {
  const seg = personalShopperItemPath(id);
  if (!seg) return Promise.reject({ data: { message: "Product id is missing" } });
  return patch(`/personal-shopper/items/${seg}/add-note`, data);
};

/** GET /personal-shopper/items/:itemId/notes */
export const personalShopperGetProductNotes = (id) => {
  const seg = personalShopperItemPath(id);
  if (!seg) return Promise.reject({ data: { message: "Product id is missing" } });
  return get(`/personal-shopper/items/${seg}/notes`);
};

/** POST /personal-shopper/items/:itemId/upload-images */
export const personalShopperProductUploadImages = ({ id, formData }) => {
  const seg = personalShopperItemPath(id);
  if (!seg) return Promise.reject({ data: { message: "Product id is missing" } });
  return upload(`/personal-shopper/items/${seg}/upload-images`, formData);
};

/** DELETE /personal-shopper/items/:itemId/images */
export const personalShopperProductDeleteImage = ({ id, imageUrl }) => {
  const seg = personalShopperItemPath(id);
  if (!seg) return Promise.reject({ data: { message: "Product id is missing" } });
  return deleteRequest(`/personal-shopper/items/${seg}/images`, { imageUrl });
};

export const personalShopperGetById = (data) => {
  return get(`/personal-shopper/items/${data.id}`);
};

export const personalShopperApi = {
  personalShopperItemsListLegacy,
  threadUser,
  threadChat,
  personalShopperItemsList,
  personalShopperDropDownList,
  personalShopperProductIntakeUpdate,
  personalShopperProductStatusChange,
  personalShopperAddNoteToProduct,
  personalShopperGetProductNotes,
  personalShopperProductUploadImages,
  personalShopperProductDeleteImage,
  personalShopperGetById,
};